export const PositionTrackerIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_40328_108352)' opacity='1'>
        <path
          d='M10.332 2.33398V1.33398M12.9582 3.04109L13.6654 2.33398M13.6722 5.66732H14.6722M14.6324 8.66732C14.298 12.0362 11.4556 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6825 1.33203 8.00065C1.33203 4.54375 3.96315 1.70138 7.33203 1.3669M7.9987 5.33398H10.6654V8.00065M10.4118 5.33398C8.84223 7.55238 6.25627 9.00065 3.33203 9.00065C2.66343 9.00065 2.01251 8.92492 1.38738 8.78165'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_40328_108352'>
          <rect fill='currentColor' height='16' width='16' />
        </clipPath>
      </defs>
    </svg>
  )
}
